import { Flex, FlexItem, Title } from '@patternfly/react-core'
import * as React from 'react'

export const NoPatientCard = () => {
  return (
    <Flex direction={{ default: 'column' }}>
      <FlexItem>
        <Flex direction={{ default: 'row' }}>
          <FlexItem>
            <Title headingLevel="h2" size="lg">
              Patient
            </Title>
          </FlexItem>
        </Flex>
      </FlexItem>

      <FlexItem>
        <Flex direction={{ default: 'row' }}>No patient selected.</Flex>
      </FlexItem>
    </Flex>
  )
}
